import {useSearchParams} from 'react-router-dom';
import {sha256} from 'js-sha256';
import {setUserToken} from '../../../../utils/api';

// Shared by ZeroNeet's 3 independent dashboard pages (Activities/Beneficiaries/Collaboration),
// each its own route with its own subset of survey id params, per the guideline PDF (AP2R1):
// dashboard 1/2/3 each live on a separate host-platform page, not as tabs of one page.
export const useZeroNeetAuth = (surveyParamNames: string[]) => {
    const [searchParams] = useSearchParams();

    const container = searchParams.get('container_id');
    const uoaId = searchParams.get('uoa_id');
    const hashKey = searchParams.get('key');
    const token = searchParams.get('token');
    const surveyIds: Record<string, string | null> = Object.fromEntries(
        surveyParamNames.map((name) => [name, searchParams.get(name)]),
    );

    const hashKeyLocal = sha256(process.env.REACT_APP_HASH_KEY_ZERO_NEET || '');

    if (token) {
        setUserToken(token);
    }

    const isAuthorized = !!(
        container &&
        uoaId &&
        hashKey === hashKeyLocal &&
        surveyParamNames.every((name) => surveyIds[name])
    );

    return {container, uoaId, surveyIds, isAuthorized};
};
